"use client";

import { NextImage } from "../NextImage";
import React from "react";
import { TabProps } from "./types";

/**
 * Tab component displays a category with icon and title.
 * Used for category navigation in the HomeQuestionCard component.
 */
export const Tab: React.FC<TabProps> = ({
  title,
  isActive = false,
  onClick,
  iconUrl,
}) => {
  return (
    <div
      data-openreplay-label="HomeQuestionCard · Tab · div"
      role="tab-item"
      className="min-w-[131px] tab_item p-3 gap-1"
      data-actived={isActive}
      onClick={onClick}
    >
      <div className="flex-shrink-0">
        <NextImage src={iconUrl} alt="" width={15} height={15} />
      </div>
      <h2
        aria-label="Tab h2"
        data-openreplay-label="Tab h2 Semantic"
        id="sem-tab-h2"
        className="body_medium_m"
      >
        {title}
      </h2>
    </div>
  );
};
